import React from 'react';
import { EDM_UI } from '../../../../utils/edm';
import type { EdmContentPath } from '../../../../hooks/useEdmCampaigns';

/**
 * The editor's content mode. 'blocks' (edm_content only) is an editor mode,
 * not a server content path: blocks are saved as contentPath 'custom_html'
 * plus the block list, which the server compiles to HTML.
 */
export type EdmEditorMode = EdmContentPath | 'blocks';

const BRANDED = { value: 'fixed_layout' as const, label: 'Branded layout' };
const BLOCKS = { value: 'blocks' as const, label: 'Blocks' };
const PASTE = { value: 'custom_html' as const, label: 'Paste your own HTML' };

const ContentPathPicker: React.FC<{
  value: EdmEditorMode;
  onChange: (v: EdmEditorMode) => void;
  disabled?: boolean;
  /** Offer Blocks (edm_content). Absent = the Phase 1c two options. */
  allowBlocks?: boolean;
}> = ({ value, onChange, disabled, allowBlocks }) => {
  const options: Array<{ value: EdmEditorMode; label: string }> = allowBlocks ? [BRANDED, BLOCKS, PASTE] : [BRANDED, PASTE];
  return (
    <div className="flex gap-3" role="radiogroup" aria-label="Content type">
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          role="radio"
          aria-checked={value === o.value}
          disabled={disabled}
          onClick={() => onChange(o.value)}
          className={`${value === o.value ? EDM_UI.segmentActive : EDM_UI.segmentIdle} disabled:opacity-50`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
};

export default ContentPathPicker;
